/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit VolumeIndicator/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function VolumeIndicator({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/AiRecorder/Content/State/Initial/SettingsAction/VolumeIndicator"
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let recorderDeviceVolumeValueData = fromData.useDataFormat({ viewPath,
context: 'recorder',
path: 'deviceVolume',
format: fromFormat.percentage,
})
let dtColorsGreen200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.200'
        })
  return (<React.Fragment
>
<div
  data-testid="VolumeIndicator.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-1GPqMB': dtColorsNeutral200,'--btlr-2-1GPqMB': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-3-1GPqMB': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-4-1GPqMB': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-5-1GPqMB': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="VolumeIndicator.Vertical:1"
  data-view-path={viewPath}
 style={{'--w-6-1GPqMB': typeof recorderDeviceVolumeValueData === 'number' ? `${recorderDeviceVolumeValueData}px` : recorderDeviceVolumeValueData,'--bc-7-1GPqMB': dtColorsGreen200}}
 className={`views-block ${styles.Vertical1}`}
/>
</div>
{children}
</React.Fragment>)
}